<template>
        <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">

  <p v-if="moduleName"> 删除该{{moduleName}}时将同时删除该{{moduleName}}下的所有{{subName}}！ </p>
  
  <p>是否确定删除？</p>
  
  <span slot="footer" class="dialog-footer">
    <el-button @click="isCancel()">取 消</el-button>
    <el-button type="primary" @click="isDelete()">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
export default {
    props:{dialogVisible:Boolean,moduleName:String,subName:String},
    data() {
        return {
        }
    },
    methods: {
        handleClose(){
           this.$emit("cancel")
        },
        isCancel(){
            this.$emit("cancel")
        },
        isDelete(){
            this.$emit("delete")
        }
    },
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__body{
    text-align: center;
    p{
      margin-bottom:5px;
    }
}
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/template/DeleteHint.vue